import gsap from '../lib/gsap.min';
import ScrollTrigger from '../lib/ScrollTrigger.min';

export function mosaicSingleFunc() {
	const mosaicParts = document.querySelectorAll('.mosaic_single');
	if (!mosaicParts.length) return;

	const COLOR = '#4266c9';

	mosaicParts.forEach(part => {
		const canvas = part.querySelector('.mosaic_canvas');
		if (!canvas) return;

		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		// リサイズ時に更新するサイズ変数
		let baseWidth, baseHeight, SIZE, HALF, CUTOUT_RADIUS, CIRCLE_RADIUS, moveDistance, BOX_Y;

		const resize = () => {
			const dpr = window.devicePixelRatio || 1;
			baseWidth = document.documentElement.clientWidth;
			SIZE = Math.round(baseWidth / 1.3);
			HALF = SIZE / 2;
			CUTOUT_RADIUS = HALF + 0.05;
			CIRCLE_RADIUS = HALF + 0.3;
			moveDistance = Math.round(SIZE * 0.3);
			baseHeight = SIZE + moveDistance;
			BOX_Y = baseHeight - SIZE;

			canvas.width = Math.round(baseWidth * dpr);
			canvas.height = Math.round(baseHeight * dpr);
			canvas.style.width = `${baseWidth}px`;
			canvas.style.height = `${baseHeight}px`;
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
		};

		const drawBoxShape = () => {
			const prevComposite = ctx.globalCompositeOperation;
			ctx.beginPath();
			ctx.rect(0, BOX_Y, SIZE, SIZE);
			ctx.fill();

			ctx.globalCompositeOperation = 'destination-out';
			ctx.beginPath();
			ctx.arc(HALF, BOX_Y + HALF, CUTOUT_RADIUS, 0, Math.PI * 2);
			ctx.fill();
			ctx.globalCompositeOperation = prevComposite;
		};

		const drawCircleShape = (ox, oy) => {
			ctx.beginPath();
			ctx.arc(SIZE + ox, BOX_Y + HALF + oy, CIRCLE_RADIUS, 0, Math.PI * 2);
			ctx.fill();
		};

		const render = (progress = 0) => {
			const ox = -HALF + moveDistance * progress;
			const oy = -moveDistance * progress;

			ctx.clearRect(0, 0, baseWidth, baseHeight);
			ctx.fillStyle = COLOR;
			ctx.globalCompositeOperation = 'source-over';

			drawBoxShape();

			// 右上象限のみ XOR
			ctx.save();
			ctx.beginPath();
			ctx.rect(HALF, BOX_Y, HALF, HALF);
			ctx.clip();
			ctx.globalCompositeOperation = progress > 0 ? 'xor' : 'source-over';
			drawCircleShape(ox, oy);
			ctx.restore();

			// 他3象限は source-over
			ctx.save();
			ctx.beginPath();
			ctx.rect(0, 0, baseWidth, baseHeight);
			ctx.rect(HALF, BOX_Y, HALF, HALF); // evenodd で右上象限を除外
			ctx.clip('evenodd');
			ctx.globalCompositeOperation = 'source-over';
			drawCircleShape(ox, oy);
			ctx.restore();
		};

		resize();
		render(0);
		let hasPlayed = false;
		let playTween = null;

		ScrollTrigger.create({
			trigger: part,
			start: 'top center',
			invalidateOnRefresh: true,
			onEnter: () => {
				if (hasPlayed) return;
				hasPlayed = true;
				if (playTween) playTween.kill();
				const state = { progress: 0 };
				playTween = gsap.to(state, {
					progress: 1,
					duration: 1.4,
					ease: 'power2.inOut',
					onUpdate: () => render(state.progress),
					onComplete: () => render(1),
				});
			},
			onRefresh: () => {
				resize();
				render(hasPlayed ? 1 : 0);
			},
		});
	});
}
